/* import __COLOCATED_TEMPLATE__ from './multilingual.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {};
}

export default class Multilingual extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare session: $TSFixMe;

  get title() {
    return this.intl.t('new-settings.submenu.personal.multilingual');
  }

  get canAccessLanguageSettings() {
    return true;
    // return this.session.teammate.hasCopilotAccess
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::Multilingual': typeof Multilingual;
    'new-settings/personal/multilingual': typeof Multilingual;
  }
}
